import { Trans } from 'react-i18next';

import { Button } from '@actual-app/components/button';
import { Text } from '@actual-app/components/text';

import { useAuth } from '#auth/AuthProvider';
import { Permissions } from '#auth/types';
import { useEnableBankingStatus } from '#hooks/useEnableBankingStatus';
import { pushModal } from '#modals/modalsSlice';
import { useDispatch } from '#redux';

import { Setting } from './UI';

/**
 * B6 · H92: los datos técnicos de Enable Banking (Application ID y archivo
 * .pem) viven en Ajustes › Avanzado. Abre el mismo formulario de siempre:
 * no cambia cómo se guarda la clave. Son las de la aplicación de Enable
 * Banking de Rumbo, comunes a todos: solo las ve el admin.
 */
export function EnableBankingSettings() {
  const dispatch = useDispatch();
  const { configuredEnableBanking } = useEnableBankingStatus();
  const { hasPermission } = useAuth();
  if (!hasPermission(Permissions.ADMINISTRATOR)) {
    return null;
  }
  return (
    <Setting
      primaryAction={
        <Button
          data-testid="ajustes-enablebanking"
          onPress={() =>
            dispatch(
              pushModal({
                modal: {
                  name: 'enablebanking-init',
                  options: { onSuccess: () => undefined },
                },
              }),
            )
          }
        >
          {configuredEnableBanking ? (
            <Trans>Change bank connection details</Trans>
          ) : (
            <Trans>Set up bank connection</Trans>
          )}
        </Button>
      }
    >
      <Text>
        <Trans>
          <strong>Bank connection (Enable Banking)</strong> needs an application
          ID and a .pem key file. You only do this once.
        </Trans>
      </Text>
    </Setting>
  );
}
